import { RouteObject } from "react-router-dom";
import { ImageCaptureList } from "../pages/admin/image-captures/ImageCaptureList";
import { ImageCaptureDetail } from "../pages/admin/image-captures/ImageCaptureDetail";
import { ImageCaptureCreate } from "../pages/admin/image-captures/ImageCaptureCreate";
import { ImageCaptureEdit } from "../pages/admin/image-captures/ImageCaptureEdit";
import { ImageCaptureAccountList } from "../pages/admin/image-captures/accounts/ImageCaptureAccountList";
import { ImageCaptureAccountDetail } from "../pages/admin/image-captures/accounts/ImageCaptureAccountDetail";
import { ImageCaptureAccountCreate } from "../pages/admin/image-captures/accounts/ImageCaptureAccountCreate";
import { ImageCaptureAccountEdit } from "../pages/admin/image-captures/accounts/ImageCaptureAccountEdit";
import { ImageCapturePageCreate } from "../pages/admin/image-captures/pages/ImageCapturePageCreate";
import { ImageCapturePageDetail } from "../pages/admin/image-captures/pages/ImageCapturePageDetail";
import { ImageCapturePageEdit } from "../pages/admin/image-captures/pages/ImageCapturePageEdit";

export const imageCapturesRoutes: RouteObject[] = [
  {
    id: "image-captures-list",
    index: true,
    element: <ImageCaptureList />,
  },
  {
    id: "image-capture-detail",
    path: ":id",
    element: <ImageCaptureDetail />,
  },
  {
    id: "image-capture-create",
    path: "create",
    element: <ImageCaptureCreate />,
  },
  {
    id: "image-capture-edit",
    path: ":id/edit",
    element: <ImageCaptureEdit />,
  },
  {
    id: "image-capture-page-create",
    path: ":id/pages/create",
    element: <ImageCapturePageCreate />,
  },
  {
    id: "image-capture-page-detail",
    path: ":id/pages/:pageId",
    element: <ImageCapturePageDetail />,
  },
  {
    id: "image-capture-page-edit",
    path: ":id/pages/:pageId/edit",
    element: <ImageCapturePageEdit />,
  },
  // Accounts routes
  {
    id: "image-capture-accounts-list",
    path: "accounts",
    element: <ImageCaptureAccountList />,
  },
  {
    id: "image-capture-account-detail",
    path: "accounts/:id",
    element: <ImageCaptureAccountDetail />,
  },
  {
    id: "image-capture-account-create",
    path: "accounts/create",
    element: <ImageCaptureAccountCreate />,
  },
  {
    id: "image-capture-account-edit",
    path: "accounts/:id/edit",
    element: <ImageCaptureAccountEdit />,
  },
];
